import React, { useEffect, useState } from "react";
import "./LoanLanguages.scss";
import { Box, Button, TextField, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import { commonRunQuery, loansCreateLanguage, loansUpdateLanguage } from "../../../util/API/loans";
import LoanSetupTable from "../../../components/LoanSetupTable/LoanSetupTable";
import CustomLoansForm from "../../../components/UI/CustomLoansForm/CustomLoansForm";
import LoanLangTagsTable from "../../../components/LoanLangTagsTable/LoanLangTagsTable";

const LoanLanguages = ({ setAlert, setAlertOpen }) => {
    const [viewMode, setViewMode] = useState("table");
    const [languagesArr, setLanguagesArr] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState(null);
    const [formValues, setFormValues] = useState(null);
    const [langIdTableData, setLangIdTableData] = useState([]);
    const [selectedLangId, setSelectedLangId] = useState(null);
    const [value, setValue] = useState(0);

    const dispatch = useDispatch();

    const columns = [
        {
            label: 'Language',
            getValue: (row) => row?.lang?.langID ?? ''
        },
        {
            label: 'Tag',
            getValue: (row) => row?.lang?.langTagID ?? ''
        }   
    ];

    useEffect(()=> {
        getAllLanguages();
    }, []);

    const getAllLanguages = async () => {
        try {
            let response = await commonRunQuery(277, "");
            if (
                response?.data?.header?.callStatus === "1" &&
                response?.data?.header?.reccount !== "0"
            ) {
                const languagesArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];
    
                setLanguagesArr(languagesArray);
                console.log("languagesArray=======================", languagesArray);
            } else {
                setLanguagesArr([]);
            }
        } catch (error) {
            console.log("getAllCategories_error=======================", error);
        }
    };

    const handleEdit = (rowData) => {
        console.log("handleEdit_rowData=======================", rowData);
        setSelectedLanguage(rowData);
        setViewMode("edit")
    }

    const handleSubmit = async(submittedValue) => {
        console.log("submittedValue=======================", submittedValue);
        
        try {
            if (submittedValue?.langID.trim() === "") {
                setAlert({
                    showAlert: true,
                    message: "Please enter a language code.",
                    severity: "error",
                    header: "Error",
                });
                return;
            }
            const response = await loansCreateLanguage("", submittedValue?.langID.toUpperCase());
            console.log("handleSubmit_response=======================", response);

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Language created successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLanguages();
                setViewMode("table");
            } else if(response?.Status == "2" && response?.payload?.callStatus=="0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in creating language. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleUpdate = async(rowData) => {
        try {
            if (rowData?.langID.trim() === "") {
                setAlert({
                    showAlert: true,
                    message: "Please enter a language code.",
                    severity: "error",
                    header: "Error",
                });
                return;
            }
            const response = await loansUpdateLanguage("", rowData?.langID.toUpperCase(), selectedLanguage?.lang?.langTagID);
            console.log("handleSubmit_response=======================", response);

            if(response?.data?.header?.callStatus === "1") {
                setAlert({
                    showAlert: true,
                    message: "Language updated successfully.",
                    severity: "success",
                    header: "Success",
                });
                setAlertOpen(true);

                getAllLanguages();
                setViewMode("table");
                setSelectedLanguage(null);
            } else if(response?.Status == "2" && response?.payload?.callStatus=="0") {
                setAlert({
                    showAlert: true,
                    message: response?.payload?.msg,
                    severity: "error",
                    header: "Error",
                });
            }
        } catch (error) {
            setAlert({
                showAlert: true,
                message: "There was an error in updating language. " + error,
                severity: "error",
                header: "Error",
            });
        }
    }

    const handleViewLangTags = async(row) => {
        console.log("handleViewLangTags============", row);
        setSelectedLangId(row?.lang?.langTagID);
        setViewMode("viewLangIdTable");
    }

    return (
        <Box sx={{ p: 2 }} className="loan-languages-container">
            {viewMode === "table" ? (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            Languages
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("create");
                                setFormValues({}); // reset form
                            }}
                        >
                            Create Language
                        </Button>
                    </Box>

                    <LoanSetupTable
                        data={languagesArr}
                        columns={columns}
                        title="Languages"
                        formatRow={(row) => [
                            row?.lang?.langID,
                            row?.lang?.langTagID
                        ]}
                        isEdit={true}
                        handleEdit={handleEdit}
                        handleViewLangTags={handleViewLangTags}
                        // viewLoanTypes={true}
                        // handleViewLoanTypes={handleViewLoanTypes}
                        // isDelete={true}
                        // handleDelete={handleDeleteConfirmation}
                        />
                </Box>

            ) : viewMode === "viewLangIdTable" ? (
                <Box>
                    <Box sx={{ borderRadius: "12px" }}>
                        <LoanLangTagsTable setAlert={setAlert} setAlertOpen={setAlertOpen} langIdTableData={langIdTableData} setViewMode={setViewMode} setValue={setValue} selectedLangId={selectedLangId} fromTab={"LoanLanguages"} />
                    </Box>
                </Box>
            ) : null}

            {viewMode !== "table" && viewMode !== "viewLangIdTable" && (
                <Box>
                    <Box className="d-flex justify-content-between align-items-center mb-2">
                        <Typography variant="h6">
                            {viewMode === "create" ? "Create Loan Product" : "Edit Loan Product"}
                        </Typography>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                setViewMode("table");
                                setSelectedLanguage(null);
                            }}
                        >
                            Return
                        </Button>
                    </Box>

                    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 500, mt: 2 }}>
                        <CustomLoansForm
                            formValues={viewMode === "edit" ? selectedLanguage?.lang : null}
                            formName={"createlanguage"}
                            buttonText={viewMode === "edit" ? "Update" : "Submit"}
                            loadingButtonText={viewMode === "edit" ? "Updating Language ..." : "Creating Language ..."}
                            onSubmit={viewMode === "create" ? handleSubmit : handleUpdate}
                            initialValues={{
                                langID: selectedLanguage?.lang?.langID,
                            }}
                            isEdit={viewMode == "edit" ? true : false}
                            isCreate={viewMode == "create" ? true : false}
                        />
                    </Box>
                </Box>
            )}
        </Box>
    )
}

export default LoanLanguages;